import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx, _cache) {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.getClass('form-footers__inner'))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.components, (component, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createCommentVNode(" Render Form Footer Text "),
        (component.type=='footer_text')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.getClass('footer__text'))
            }, [
              _createElementVNode("p", {
                innerHTML: _ctx.decodeTags(component.label),
                style: _normalizeStyle(_ctx.computedFontStyle)
              }, null, 12 /* STYLE, PROPS */, _hoisted_1)
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Render Form Footer buttons "),
        (component.type=='button')
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass([_ctx.getClass('footer__button'), _ctx.shouldHideButton(component) ? _ctx.getClass('hide'): ''])
            }, [
              _createVNode(_component_Button, {
                component: component,
                formValid: _ctx.formValid
              }, null, 8 /* PROPS */, ["component", "formValid"])
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
    }), 256 /* UNKEYED_FRAGMENT */))
  ], 2 /* CLASS */))
}